export var Box;

(function (Box) {
  Box["Address"] = "address";
  Box["Article"] = "article";
  Box["Aside"] = "aside";
  Box["Div"] = "div";
  Box["Footer"] = "footer";
  Box["Header"] = "header";
  Box["Main"] = "main";
  Box["Nav"] = "nav";
  Box["Section"] = "section";
  Box["Li"] = "li";
})(Box || (Box = {}));